import React, { Suspense, useEffect } from "react";
import { PageLoader } from "./components/loader";
import { AuthProvider } from "./context/authContext";
import Router from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useAnalytics } from "./hooks/analytics.hook";
import { AppErrorBoundary } from "./components/error-boundary";
function App() {
  const { init } = useAnalytics();

  useEffect(() => {
    init();
  }, []);

  return (
    <Suspense fallback={<PageLoader />}>
      <AppErrorBoundary>
        <AuthProvider>
          <I18nextProvider i18n={i18n}>
            <Router />
          </I18nextProvider>
        </AuthProvider>
      </AppErrorBoundary>
    </Suspense>
  );
}
export default App;
